/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from 'react';
import { LftTrialCountdownExperiment } from '../../experiments/LftCountdown/LftSidePaneTrialCountdown';

export const LftTrialCountdownView = () => {
    return <LftTrialCountdownExperiment />;
};

export default LftTrialCountdownView;
